import { HttpErrorResponse, HttpEvent, HttpHandler, HttpInterceptor, HttpRequest } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { Observable, throwError } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { HttpError } from '../00_modules/core/common/http-error';
import { DatIssue } from '../00_modules/vehicle/components/vinservice/DatIssue';

@Injectable()
export class ErrorCatchingInterceptor implements HttpInterceptor {
    constructor(public translateService: TranslateService) {}

    intercept(request: HttpRequest<unknown>, next: HttpHandler): Observable<HttpEvent<unknown>> {
        return next.handle(request).pipe(
            catchError(error => {
                return throwError(() => {
                    if (error instanceof HttpErrorResponse) {
                        if (typeof error.error === 'string' && error.error.indexOf('errorCode') > 0) {
                            return Object.assign(new DatIssue(), JSON.parse(error.error)) as DatIssue;
                        } else if (JSON.stringify(error.error).indexOf('errorCode') > 0) {
                            return Object.assign(new DatIssue(), error.error) as DatIssue;
                        } else if (error.error && error.error.errors) {
                            if (error.error.errors[0].key) {
                                return new Error(this.translateService.instant(error.error.errors[0].key));
                            }
                            return new Error(error.error.errors[0].message);
                        } else if (error.status && error.statusText) {
                            let httpError = new HttpError();
                            httpError.status = error.status;
                            httpError.statusText = error.statusText;
                            return httpError;
                        } else {
                            return new Error(error.error);
                        }
                    } else {
                        return new Error(error);
                    }
                });
            })
        );
    }
}
